import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=59c27e9b&"
import script from "./frame.vue?vue&type=script&lang=js&"
export * from "./frame.vue?vue&type=script&lang=js&"
import style0 from "./frame.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./frame.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c27e9b')) {
      api.createRecord('59c27e9b', component.options)
    } else {
      api.reload('59c27e9b', component.options)
    }
    module.hot.accept("./frame.vue?vue&type=template&id=59c27e9b&", function () {
      api.rerender('59c27e9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/frame.vue"
export default component.exports